<template>
  <!-- eslint-disable max-len -->
  <div class="aspect-w-1 aspect-h-1 overflow-hidden cursor-pointer" @click="onClick">
    <img :src="mediaItem.url" class="w-full h-full object-cover rounded-lg border" />
  </div>
</template>

<script>
export default {
  props: {
    mediaItem: {
      type: Object,
      required: true,
    },
  },
  methods: {
    onMediaItemDeleted() {
      this.$emit('deleted');
    },
    onClick() {
      this.$modal.show({
        component: () => import('@/components/MediaLibrary/ManageMediaItemDialog.vue'),
        props: {
          mediaItemId: this.mediaItem.id,
        },
        on: {
          deleted: this.onMediaItemDeleted,
        },
        hideEvent: 'close',
      });
    },
  },
};
</script>
